module.exports = __webpack_public_path__ + "static/media/Baltic_Main.a786ac74.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Baltic_Main.webp
// module id = ./src/assets/Baltic_Main.webp
// module chunks = 0